/** On server side it is called ParameterDto*/
export interface TaskParameter {
  parameterId: string;
  systemTaskId: string;
  parameters: any[];
  outputs: any[];
  urlParameters: any[];
  descriptionParameters: any[];
}
